import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Users } from "lucide-react";
import { KineticLines, Reveal, Eyebrow } from "@/components/site/Reveal";
import { Marquee } from "@/components/site/Marquee";
import { INDUSTRIES } from "@/data/content";

export default function Industries() {
  useEffect(() => {
    document.title = "B2B Technology Verticals & Industries We Serve | Vyacomm Media";
  }, []);

  return (
    <div data-testid="industries-page">
      <section className="grain hero-grid-lines relative overflow-hidden bg-navy pb-24 pt-[200px]">
        <div className="pointer-events-none absolute -left-40 top-16 h-[420px] w-[420px] rounded-full bg-cobalt/20 blur-[140px]" />
        <div className="relative z-10 mx-auto max-w-[1808px] px-5 sm:px-8 lg:px-12 2xl:px-14">
          <Reveal delay={0.05} y={16}>
            <Eyebrow dark>Industries & Audience Reach</Eyebrow>
          </Reveal>
          <h1 className="mt-6 max-w-4xl font-jakarta text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
            <KineticLines lines={["Precision Audiences Across", "Every Enterprise Tech Vertical."]} accentIndex={1} />
          </h1>
          <Reveal delay={0.5}>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">
              Specialized B2B demand generation across SaaS, cybersecurity, cloud infrastructure, FinTech, AI, and
              enterprise technology — reaching the exact personas who sign the contracts.
            </p>
          </Reveal>
        </div>
      </section>

      <Marquee dark={false} />

      <section className="bg-canvas py-24 sm:py-32" data-testid="industries-list">
        <div className="mx-auto max-w-[1808px] px-5 sm:px-8 lg:px-12 2xl:px-14">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.name} delay={0.05}>
              <div
                className="group grid gap-6 border-t border-line py-14 transition-colors duration-500 last:border-b hover:bg-white sm:grid-cols-12 sm:px-6"
                data-testid={`industry-row-${i + 1}`}
              >
                <span className="font-jakarta text-6xl font-extrabold text-line transition-colors duration-500 group-hover:text-cobalt sm:col-span-2">
                  0{i + 1}
                </span>
                <div className="sm:col-span-5">
                  <h2 className="font-jakarta text-2xl font-extrabold tracking-tight text-navy sm:text-3xl">{ind.name}</h2>
                  <p className="mt-4 text-base leading-relaxed text-slate-600">{ind.desc}</p>
                </div>
                <div className="sm:col-span-5">
                  <p className="flex items-center gap-2 font-mono2 text-[10px] tracking-[0.22em] text-cobalt">
                    <Users className="h-3.5 w-3.5" /> KEY PERSONA REACH
                  </p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {ind.personas.map((p) => (
                      <span
                        key={p}
                        className="rounded-full border border-line bg-white px-4 py-2 text-xs font-semibold text-charcoal transition-colors duration-300 group-hover:border-cobalt/40"
                      >
                        {p}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="grain relative overflow-hidden bg-navy py-20" data-testid="industries-cta">
        <div className="relative z-10 mx-auto flex max-w-[1808px] flex-col items-start justify-between gap-6 px-5 sm:flex-row sm:items-center sm:px-8 lg:px-12 2xl:px-14">
          <h2 className="max-w-xl font-jakarta text-2xl font-extrabold text-white sm:text-3xl">
            Need audience counts for your exact vertical and persona mix?
          </h2>
          <Link
            to="/contact-us"
            data-testid="industries-cta-btn"
            className="group inline-flex shrink-0 items-center gap-2 rounded-full bg-cobalt px-7 py-4 text-sm font-bold text-white transition-all duration-300 hover:scale-[1.03] hover:bg-[#1d4fd7]"
          >
            Request Audience Count
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </section>
    </div>
  );
}
